<div class="container-fluid  pt-4 pb-4 mb-1 d-flex flex-column">
  <h1 class="display-404 text-center">404</h1>
  <div class="text-center">
    <h2>Page Not Found</h2>
    <p class="text-sm">It seems we can’t find the page you are looking for.
      <a routerLink="/app">Go back to Homepage</a>
  </div>
</div>